module.exports = __webpack_public_path__ + "images/privateer-af822a14d1cd7016590ade3f7655b4db.png";